import { inject, ref } from "vue";

import type { InjectionKey, Ref } from "vue";

export const WINDOW_KEY = Symbol() as InjectionKey<Ref<Window>>;

export function useWindow() {
  const fallback = ref(globalThis.window);
  return inject(WINDOW_KEY, fallback);
}
